import { UserSchedule } from '../../models/user-schedule.model';

export enum ActionTypes {
  RememberUserSchedule = '[RememberUserSchedule] action',
  ResetUserSchedule = '[ResetUserSchedule] action',
}

export class RememberUserSchedule {
  public static readonly type = ActionTypes.RememberUserSchedule;
  constructor(
    public payload: UserSchedule,
    public isLoaded: boolean
  ) { }
}

export class ResetUserSchedule {
  public static readonly type = ActionTypes.ResetUserSchedule;
  constructor() { }
}
